import _regeneratorRuntime from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/v2/v2/webapp/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
import { StorageClient } from "./generated/src";
/**
 * @internal
 */

export var StorageContextClient = /*#__PURE__*/function (_StorageClient) {
  _inherits(StorageContextClient, _StorageClient);

  var _super = _createSuper(StorageContextClient);

  function StorageContextClient() {
    _classCallCheck(this, StorageContextClient);

    return _super.apply(this, arguments);
  }

  _createClass(StorageContextClient, [{
    key: "sendOperationRequest",
    value: function () {
      var _sendOperationRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(operationArguments, operationSpec) {
        var operationSpecToSend;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                operationSpecToSend = Object.assign({}, operationSpec);

                if (operationSpecToSend.path === "/{containerName}" || operationSpecToSend.path === "/{containerName}/{blob}") {
                  operationSpecToSend.path = "";
                }

                return _context.abrupt("return", _get(_getPrototypeOf(StorageContextClient.prototype), "sendOperationRequest", this).call(this, operationArguments, operationSpecToSend));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function sendOperationRequest(_x, _x2) {
        return _sendOperationRequest.apply(this, arguments);
      }

      return sendOperationRequest;
    }()
  }]);

  return StorageContextClient;
}(StorageClient);